'use client';

import { useMediaQuery } from '@mui/material';
import useCheckisSmallerBaseDeskTopSize from '@/hooks/useCheckisSmallerBaseDeskTopSize';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

const Header = ({ isBackgroundTransparent, optioinalButton, isNeedPadding }: { optioinalButton?: React.ReactElement; isBackgroundTransparent?: boolean; isNeedPadding?: boolean }) => {
  const isMobile = useMediaQuery('(max-width:1024px)');
  const isSmallerBaseDesktop = useCheckisSmallerBaseDeskTopSize();

  const innerPaddingX = isSmallerBaseDesktop || isNeedPadding ? 'md:px-5' : 'md:px-[4.44rem]';

  return (
    <header className={`fixed w-full h-[50px] md:h-[74px] top-0 left-0 flex justify-center items-center z-[101] shadow-none ${isBackgroundTransparent ? 'bg-transparent' : 'bg-white'}`}>
      <div className={`w-full max-w-[1440px] h-full flex justify-between bg-white px-4 ${innerPaddingX} py-[10px] md:py-[18px] overflow-visible`}>
        {isMobile ? <MobileHeader /> : <DesktopHeader />}
      </div>
    </header>
  );
};

export default Header;
